import axios from "axios";
import {
  CHANGE_INSPECTION_STATUS_FAILURE,
  CHANGE_INSPECTION_STATUS_REQUEST,
  CHANGE_INSPECTION_STATUS_SUCCESS,
  CREATE_CHALLAN_FAILURE,
  CREATE_CHALLAN_REQUEST,
  CREATE_CHALLAN_SUCCESS,
  CREATE_NEW_SERIAL_CODE_FAILURE,
  CREATE_NEW_SERIAL_CODE_REQUEST,
  CREATE_NEW_SERIAL_CODE_SUCCESS,
  DELETE__CHALLAN_FAILURE,
  DELETE__CHALLAN_REQUEST,
  DELETE__CHALLAN_SUCCESS,
  EVALUATE_DEFECT_FAILURE,
  EVALUATE_DEFECT_REQUEST,
  EVALUATE_DEFECT_SUCCESS,
  GET__CHALLAN_FAILURE,
  GET__CHALLAN_REQUEST,
  GET__CHALLAN_SUCCESS,
  GET_BASIC_QUALITY_FAILURE,
  GET_BASIC_QUALITY_REQUEST,
  GET_BASIC_QUALITY_SUCCESS,
  GET_MEDIA_FAILURE,
  GET_MEDIA_REQUEST,
  GET_MEDIA_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_REQUEST,
  GET_SETTINGS_SUCCESS,
  LIST_INSPECTION_POINT_RANDOM_SCAN_FAILURE,
  LIST_INSPECTION_POINT_RANDOM_SCAN_REQUEST,
  LIST_INSPECTION_POINT_RANDOM_SCAN_SUCCESS,
  SAVE_SETTING_FAILURE,
  SAVE_SETTING_REQUEST,
  SAVE_SETTING_SUCCESS,
  SUBMIT_INSPECTION_POINT_FAILURE,
  SUBMIT_INSPECTION_POINT_REQUEST,
  SUBMIT_INSPECTION_POINT_SUCCESS,
  VIEW_DETAILS_FAILURE,
  VIEW_DETAILS_REQUEST,
  VIEW_DETAILS_SUCCESS,
} from "../Constants/AuditConstants";
import secureLocalStorage from "react-secure-storage";
import { getEnvironment } from "../Middleware/CommonFun";
import { BASEURI } from "../Middleware/axiosInstance";
import {
  UNDO_SCANNABLE_INCOMING_FAILURE,
  UNDO_SCANNABLE_INCOMING_REQUEST,
  UNDO_SCANNABLE_INCOMING_SUCCESS,
} from "../Constants/ProductionConstants";

// Falls back to REACT_APP_BASE_URI (https://erp.sevenrocks.in/v2-web-api) when nothing is stored
let uri = secureLocalStorage.getItem("BaseURI") || BASEURI;
const environment = getEnvironment(uri);

export let URI =
  environment === "staging"
    ? "https://staging-laravel.sevenrocks.in/api"
    : environment === "test"
    ? "https://erp-laravel-testlive.sevenrocks.in/api"
    : "https://laravel-live.sevenrocks.in/api";

export let IMAGE_URI =
  environment === "staging"
    ? "https://staging-laravel.sevenrocks.in"
    : environment === "test"
    ? "https://erp-laravel-testlive.sevenrocks.in"
    : "https://laravel-live.sevenrocks.in";

export let token = JSON.parse(
  secureLocalStorage.getItem("user__UUID__QualityManager")
)?.data?.token;

// Get Basic Quality Actions
export const getBasicQualityActions =
  (
    page,
    limit,
    batch_id,
    product_group_id,
    random_inspection_status,
    random_inspection_started_by_user_id,
    start_date,
    end_date,
    token
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_BASIC_QUALITY_REQUEST,
      });

      const { data } = await axios.get(
        `${URI}/QualityManager/batch_index?page=${page}&limit=${limit}&batch_id=${batch_id}&product_group_id=${product_group_id}&random_inspection_status=${random_inspection_status}&random_inspection_started_by_user_id=${random_inspection_started_by_user_id}&start_date=${start_date}&end_date=${end_date}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: GET_BASIC_QUALITY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_BASIC_QUALITY_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Media Actions
export const getMediaActions = (id, serial_code, token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_MEDIA_REQUEST,
    });

    const endpoint = serial_code
      ? `${URI}/QualityManager/list_inspection_point_media/${id}/${serial_code}`
      : `${URI}/QualityManager/list_inspection_point_media/${id}`;

    const { data } = await axios.get(`${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_MEDIA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_MEDIA_FAILURE,
      payload: error.message,
    });
  }
};

// Quality Details Actions
export const QualityDetailsActions =
  (batch_id, page, token) => async (dispatch) => {
    try {
      dispatch({
        type: VIEW_DETAILS_REQUEST,
      });

      let url = `${URI}/QualityManager/random_inspection_view_detail?batch_id=${batch_id}`;

      if (page) {
        url += `&page=${page}`;
      }

      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: VIEW_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: VIEW_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Settings Actions
export const getSettingsActions = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SETTINGS_REQUEST,
    });

    const { data } = await axios.get(`${URI}/QualityManager/settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_SETTINGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_SETTINGS_FAILURE,
      payload: error.message,
    });
  }
};

// Save Settings Actions
export const saveSettingsActions = (obj, token) => async (dispatch) => {
  try {
    dispatch({
      type: SAVE_SETTING_REQUEST,
    });

    const { data } = await axios.post(`${URI}/QualityManager/settings`, obj, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: SAVE_SETTING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SAVE_SETTING_FAILURE,
      payload: error.message,
    });
  }
};

// List Inspection Point Random Scan
export const ListInspectionPointRandomScanActions =
  (code, batch_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: LIST_INSPECTION_POINT_RANDOM_SCAN_REQUEST,
      });

      const { data } = await axios.post(
        `${URI}/QualityManager/list_inspection_point_for_random_scan`,
        { code, batch_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: LIST_INSPECTION_POINT_RANDOM_SCAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: LIST_INSPECTION_POINT_RANDOM_SCAN_FAILURE,
        payload: error.message,
      });
    }
  };

// Save Inspection Point Actions
export const SaveInspectionPointActions =
  (code, inspection_points, token) => async (dispatch) => {
    try {
      dispatch({
        type: SUBMIT_INSPECTION_POINT_REQUEST,
      });

      const { data } = await axios.post(
        `${URI}/QualityManager/submit_inspection_points_for_random_scan`,
        { code, inspection_points },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: SUBMIT_INSPECTION_POINT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SUBMIT_INSPECTION_POINT_FAILURE,
        payload: error.message,
      });
    }
  };

// Change Inspection Status Actions
export const ChangeInspectionStatusActions =
  (id, status, token) => async (dispatch) => {
    try {
      dispatch({
        type: CHANGE_INSPECTION_STATUS_REQUEST,
      });

      const { data } = await axios.post(
        `${URI}/QualityManager/change_random_inspection_status`,
        {
          batch_ids: id,
          status,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CHANGE_INSPECTION_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CHANGE_INSPECTION_STATUS_FAILURE,
        payload: error.message,
      });
    }
  };

// Evaluate Defect Actions
export const EvaluateDefectActions =
  (measurement_id, defect_id, input, token) => async (dispatch) => {
    try {
      dispatch({
        type: EVALUATE_DEFECT_REQUEST,
      });

      let url = `${URI}/QualityManager/evaluate_defect?input=${input}`;

      if (measurement_id) {
        url += `&measurement_id=${measurement_id}`;
      }

      if (defect_id) {
        url += `&defect_id=${defect_id}`;
      }

      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: EVALUATE_DEFECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EVALUATE_DEFECT_FAILURE,
        payload: error.message,
      });
    }
  };

// Create New Serial Code Actions
export const CreateNewSerialCodeActions =
  (service_name, serial_code, force_create) => async (dispatch) => {
    try {
      dispatch({
        type: CREATE_NEW_SERIAL_CODE_REQUEST,
      });

      let url = BASEURI;

      const payload = {
        service_name,
        serial_code,
        token: "1RNGF3QQ8SA",
        ...(force_create != null && { force_create }), // Only include if not null/undefined
      };

      const { data } = await axios.post(url, payload);
      dispatch({
        type: CREATE_NEW_SERIAL_CODE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_NEW_SERIAL_CODE_FAILURE,
        payload: error.message,
      });
    }
  };

// Create Challan Actions
export const CreateChallanActions =
  (service_name, token, manufacture_order_id, challan_no) =>
  async (dispatch) => {
    try {
      dispatch({
        type: CREATE_CHALLAN_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        manufacture_order_id,
        challan_no,
      });
      dispatch({
        type: CREATE_CHALLAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_CHALLAN_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Challan Actions
export const getChallanActions =
  (service_name, token, manufacture_order_id) => async (dispatch) => {
    try {
      dispatch({
        type: GET__CHALLAN_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        manufacture_order_id,
      });
      dispatch({
        type: GET__CHALLAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET__CHALLAN_FAILURE,
        payload: error.message,
      });
    }
  };

// Delete Challan Actions
export const DeleteChallanActions =
  (service_name, token, manufacture_order_id, manufacture_order_challan_id) =>
  async (dispatch) => {
    try {
      dispatch({
        type: DELETE__CHALLAN_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        manufacture_order_id,
        manufacture_order_challan_id,
      });
      dispatch({
        type: DELETE__CHALLAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: DELETE__CHALLAN_FAILURE,
        payload: error.message,
      });
    }
  };

// undo scannable Incoming Actions
export const undoScannableIncomingActions =
  (service_name, token, serial_code, inventory_id, log_id) =>
  async (dispatch) => {
    try {
      dispatch({
        type: UNDO_SCANNABLE_INCOMING_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        serial_code,
        inventory_id,
        log_id,
      });
      dispatch({
        type: UNDO_SCANNABLE_INCOMING_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UNDO_SCANNABLE_INCOMING_FAILURE,
        payload: error.message,
      });
    }
  };
